import "./menu.css";
import {Navbar} from "react-bootstrap";
import Logo from "../logo/Logo";
import MenuItems from "./MenuItems";
import {useSelector} from "react-redux";

export default function Menu() {
  const isGuest = useSelector(state => state.user.isGuest);

  return (
    <Navbar expand={'lg'}>
      <Navbar.Brand as="div">
        <Logo/>
      </Navbar.Brand>
      {isGuest ? null : <MenuItems/>}
    </Navbar>
  );
}
